
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
import ChaletIcon from '@mui/icons-material/Chalet';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import CelebrationIcon from '@mui/icons-material/Celebration';
import AirlineSeatReclineExtraIcon from '@mui/icons-material/AirlineSeatReclineExtra';
import PolicyIcon from '@mui/icons-material/Policy';;
import TtkList from './TtkList';
 
const DestinationWedTTK = ({ data }) => {
    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <p><WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since:</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p ><DirectionsCarFilledIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>How many Cars can be Parked at Your Venue ? :</b>&nbsp;<span>{data?.parkingSize}</span></p>
                        </div>
                        <div className='col-md-4'>
                            <p>  &nbsp;<b>Starting Veg Price (Per Plate) :</b>&nbsp;&#8377;&nbsp;<span>{data?.vegPrice}</span></p>
                        </div>
                    </div>

                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <p> &nbsp;<b>Starting Non Veg Price (Per Plate) :</b>&nbsp;&#8377;&nbsp;<span>{data?.nonVegPrice}</span></p>
                        </div>
                        <div className='col-md-4'>
                            <p> <ChaletIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Star Rating:</b>&nbsp;<span>{data?.starRating}</span></p>
                        </div>
                        <div className='col-md-4'>
                            <p><CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Small Party Venue :</b>&nbsp;<TtkList data={data?.smallPartiesVenue} /></p>
                        </div>
                        <div className='row mb-2'>
                            <div className='col-md-4'>
                                <p><AirlineSeatReclineExtraIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Space :</b>&nbsp;<TtkList data={data?.space} /></p>
                            </div>
                            <div className='col-md-4'>
                                <p> <ChaletIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Total No. of Rooms :</b>&nbsp;<span>{data?.roomCount}</span></p>
                            </div>

                            <div className='col-md-4'>
                                <p> <ChaletIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Average Room Price :</b>&nbsp;&#8377;&nbsp;<span>{data?.avgRoomPrice}</span></p>
                            </div>
                        </div>

                        <div className='row mb-2'>
                            <div className='col-md-4'>
                                <p> <PolicyIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Catering Policy :</b>&nbsp;<TtkList data={data?.catering} /></p>
                            </div>
                            <div className='col-md-4'>
                                <p><PolicyIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Decor Policy :</b>&nbsp;<TtkList data={data?.decorPolicy} /></p>
                            </div>
                            <div className='col-md-4'>
                                <p><PolicyIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Alcohol Policy :</b>&nbsp;<TtkList data={data?.alcoholPolicy} /></p>
                            </div>
                        </div>
                    </div>
                    <div className='row mb-2'>

                        {/* <div className='col-md-3'>
                            <p><DirectionsCarFilledIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Parking:</b>&nbsp;<TtkList data={data?.parking} /></p>
                        </div> */}
                        {/* <div className='col-md-3'>
                        <p><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>	Destination Wedding :</b>&nbsp;<TtkList data={data?.destination} /></p>
                    </div> */}
                        <div className='col-md-4'>
                            <p><PolicyIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>DJ Policy :</b>&nbsp;<TtkList data={data?.djPolicy} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p><PolicyIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Max Capacity :</b>&nbsp;<TtkList data={data?.venueCapacity} /></p>
                        </div>
                    </div>


                </div>
            </div>

        </>
    )
}

export default DestinationWedTTK